<div class="card p-4 d-flex flex-column mt-2">
    <nz-skeleton *ngIf="loading" [nzLoading]="loading" [nzActive]="true"></nz-skeleton>

    <div *ngIf="!loading" class="d-flex flex-column">
        <div class="py-1 title">Invoices Payment Customer</div>
    </div>

    <hr class="mt-2 w-100">

    <div class="d-flex justify-content-end flex-row flex-grow-1 gap-2 align-items-center mt-2">
        <div class="d-flex align-items-center">
            <div class="form-group has-search">
                <span class="form-control-feedback">
                    <i class="icon-search-normal-1"></i>
                </span>
                <input [(ngModel)]="search" (ngModelChange)="onChangeSearch($event)" type="text" class="form-control"
                    placeholder="Payment ID/Customer Name" />
            </div>
        </div>

        <div class="d-flex align-items-center">
            <div ngbDropdown class="d-inline-block" #dropdownFilter="ngbDropdown">
                <button type="button" class="btn btn-primary btn-filter" id="dropdownFilterOrder" ngbDropdownToggle>
                    <i class="icon-filter-search text-white"></i>
                </button>

                <div ngbDropdownMenu aria-labelledby="dropdownFilterOrder" style="z-index: 1050;">
                    <button ngbDropdownItem disabled class="text-black">
                        <b>Filter</b>
                    </button>
                    <div ngbDropdown placement="left" class="d-inline-block w-100">
                        <button type="button" class="btn w-100 text-start" id="dropdownStatus" ngbDropdownToggle>
                            Status
                        </button>
                        <div ngbDropdownMenu aria-labelledby="dropdownStatus">
                            <div class="px-2">
                                <div class="form-check" *ngFor="let list of status; let i = index">
                                    <input class="form-check-input" type="checkbox" [value]="list.value" [id]="list.id"
                                        [checked]="list.checked" (change)="getStatus($event, list)" />
                                    <label class="form-check-label" [for]="list.id">
                                        {{ list.label }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <button type="button" class="btn w-100 text-start ngx-daterangepicker-action"
                            id="dropdownPeriod" (click)="openDatepicker()">
                            Period
                        </button>

                        <div id="dropdownPeriod">
                            <input type="text" ngxDaterangepickerMd [(ngModel)]="selected"
                                [ngModelOptions]="{ standalone: true }" [showCustomRangeLabel]="false"
                                [keepCalendarOpeningWithRange]="true" [alwaysShowCalendars]="true" [ranges]="ranges"
                                [linkedCalendars]="true" [isInvalidDate]="isInvalidDate" [showCancel]="true"
                                [locale]="setlocale" (change)="onChangeDate($event)" opens="center" drops="down"
                                container="body" style="border: none; font-size: 14px; display: none;"
                                #datePickerInput />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="d-flex flex-column table-wrapper mt-3 w-100" style="overflow-x: auto;" (scroll)="onScroll($event)">
        <table class="table table-hover table-responsive" style="z-index: 1;">
            <thead class="sticky-top bg-light">
                <tr>
                    <th scope="col">Payment ID</th>
                    <th scope="col">Customer Name</th>
                    <th scope="col">Total Amount</th>
                    <th scope="col">Admin Fee</th>
                    <th scope="col">Status</th>
                    <th scope="col">Due Date</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of dataInvoices">
                    <td class="text-wrap align-middle">
                        <div class="d-flex flex-column">
                            <div>{{ item.payment_id }}</div>
                            <div class="text-muted">{{ item.created_at | date: 'dd MMM yyyy, HH.mm a' }}</div>
                        </div>
                    </td>
                    <td class="text-wrap align-middle">{{ item.customer_name }}</td>
                    <td class="text-wrap align-middle">
                        <div>{{ item.amount | currency : "Rp " : true : "1.0-0" }}</div>
                        <div class="text-muted">{{ getPaymentValue(item.payment_type) }}</div>
                    </td>
                    <td class="text-wrap align-middle">{{ (item.admin_fee || 0) | currency : "Rp " : true : "1.0-0" }}</td>
                    <td class="text-wrap align-middle">
                        <span class="d-flex align-items-center justify-content-center"
                            [class]=" getStatusClass(item.status)" style="width: 120px!important">{{
                            getStatusValue(item.status) }}</span>
                    </td>
                    <td class="text-wrap align-middle">{{ item.expired_at | date: 'dd MMM yyyy, HH.mm a' }}</td>
                </tr>
                <tr *ngIf="!dataInvoices || dataInvoices.length === 0">
                    <td colspan="6" class="text-center empty" style="height: 400px;">
                        <nz-empty nzNotFoundImage="simple" [nzNotFoundContent]="contentTpl">
                            <ng-template #contentTpl>
                                <span>No Data</span>
                            </ng-template>
                        </nz-empty>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
